if (!customElements.get('tabs-guarantee-accordion')) {
  class TabsGuaranteeAccordion extends HTMLElement {
    constructor() {
      super();

      this.itemElements = Array.from(this.querySelectorAll('[data-accordion-item]'));
      this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');

      this.onClick = this.onClick.bind(this);
      this.onBreakpointChange = this.onBreakpointChange.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.desktopMediaQuery.addEventListener('change', this.onBreakpointChange);

      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      this.onBreakpointChange();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.desktopMediaQuery.removeEventListener('change', this.onBreakpointChange);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    get isDesktop() {
      return this.desktopMediaQuery.matches;
    }

    get activeItemElement() {
      return this.itemElements.find((itemElement) => itemElement.hasAttribute('data-active')) || null;
    }

    onClick(event) {
      const titleElement = event.target.closest('[data-accordion-title]');

      if (!titleElement || !this.contains(titleElement)) return;

      const itemElement = titleElement.closest('[data-accordion-item]');

      if (!itemElement) return;

      if (itemElement === this.activeItemElement && this.isDesktop) return;

      this.setActiveItemElement(itemElement === this.activeItemElement ? null : itemElement);
    }

    onBreakpointChange() {
      if (this.isDesktop && !this.activeItemElement) {
        this.setActiveItemElement(this.itemElements[0] || null);
      }
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return;

      this.setActiveItemElement(event.target.closest('[data-accordion-item]'));
    }

    setActiveItemElement(activeItemElement) {
      this.itemElements.forEach((itemElement) => {
        const isActive = itemElement === activeItemElement;

        itemElement.toggleAttribute('data-active', isActive);
        itemElement.querySelector('[data-accordion-title]')?.setAttribute('aria-expanded', isActive);
      });
    }
  }

  customElements.define('tabs-guarantee-accordion', TabsGuaranteeAccordion);
}
